<template>
  <div class="card shadow card-product">
    <img :src="product.gambar" class="card-img-top" alt="" />
    <div class="card-body">
      <h5 class="card-title">{{ product.nama }}</h5>
      <p class="card-price">{{ formatRupiah(product.harga) }}</p>
      <router-link :to="'/foods/' + product.id" class="btn btn-success btn-block btn-pesan">
        <b-icon-cart></b-icon-cart> Pesan
      </router-link>
    </div>
  </div>
</template>

<script>
import { formatRupiah } from "@/utils/formatRupiah";

export default {
  name: "CardProduct",
  props: ["product"],
  methods: {
    formatRupiah,
  },
};
</script>

<style scoped>
.card-product {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.card-product .card-img-top {
  object-fit: cover;
  aspect-ratio: 1;
}
.card-product .card-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0.75rem;
}
.card-product .card-title {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.6em;
}
.card-product .card-price {
  font-size: 0.8rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-product .btn-pesan {
  font-size: 0.8rem;
  padding: 0.4rem 0.5rem;
  margin-top: auto;
}
</style>